/*****
 * Created by Allan on 2022/08/04.
 * Contact 84880528@qq.com.
 * *****/
import Vue from 'vue'
import getQueryVariable from '@/repayment/services/getQueryVariable'
import router from '@/repayment/router/'
export default{
    state:{
        sendSms:JSON.parse(localStorage.getItem('sendSms')) || {},  //短信验证码接口,获取当前手机号和唯一标识
        user:JSON.parse(localStorage.getItem('user')) || {},  //用户资料
    },
    //Getter 接受 state 作为其第一个参数,可以接受其他 getter 作为第二个参数
    getters:{
        sendSms:state=>state.sendSms,
        user:state=>state.user,
    },
    //state 作为第一个参数
    mutations:{
        mutationSendms(state,data){
            localStorage.setItem('sendSms',JSON.stringify(data));
            state.sendSms=data;
        },
        mutationUser(state,data){
            localStorage.setItem('user',JSON.stringify(data));
            state.user=data;
        },
        mutationUserSignout(state){
            localStorage.clear();
            router.replace({path:`/login?a=${getQueryVariable('a')}&n=${getQueryVariable('n')}&c=${getQueryVariable('c')}`,});
            //window.location.reload();
            //Object.keys(state).forEach(k => Vue.delete(state, k))
        },
        mutationDeleteUser(){
            localStorage.removeItem('user');
            localStorage.clear();
        },
        mutationDeleteSendm(){
            localStorage.removeItem('sendSms');
        },
    },
    //Action 提交的是 mutation，而不是直接变更状态
    actions:{
        actionSendms({ commit }, data){
            commit('mutationSendms',data)
        },
        actionUser({ commit }, data){
            commit('mutationUser',data)
        },
        actionUserSignout({ commit }, data){
            commit('mutationUserSignout')
        },
        actionDeleteUser({ commit }, data){
            commit('mutationDeleteUser')
        },
        actionDeleteSendm({ commit }, data){
            commit('mutationDeleteSendm')
        },
    },
}



// WEBPACK FOOTER //
// ./src/repayment/store/module/user.js